// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TitleBlock_wrapper__6AKIa","title":"TitleBlock_title__rV7Un","subtitle":"TitleBlock_subtitle__iEMWh","link":"TitleBlock_link__2wFhk"};